export default {
    gizmoPagesKey: "abTestPages",
    gizmoSetupKey: "abTestSetup",
    vuePageObject: "gizmoAbTest",
    customTrackingServer: "http://localhost:19090/opentracking",
    versionUrlParam: "abtestversion",
    popupId: "abtestpopup",
    checkClickTrackerParam: "checkabtest=true",
    onlyWorksFor: ["staging.telenor.no", "test.telenor.no", "localhost:9000", "localhost:9443"], // this is just used for debugging purpose, don't put live sites here
    versionLetters: ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z","Æ","Ø","Å"]
};